module.exports = __webpack_public_path__ + "static/img/wxtp_20260714114124_88_157.7120277.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/news/20260714/wxtp_20260714114124_88_157.jpg
// module id = Y/4B
// module chunks = 0